// extracted by mini-css-extract-plugin
module.exports = {"main_white":"#ffffff","main_red":"#F95428","dashbord":"styles_dashbord__3aP45","btn-group-container":"styles_btn-group-container__3y3g-","red_star":"styles_red_star__3Pge9"};